// Detail-modal overlay geometry. The modal overlays the page's content area
// exactly — top flush under the header's blue line, width matching the content
// box — by positioning against CSS variables measured from the live layout.
// Measured when the modal opens (and re-measured while open), so banners above
// the app, window resizes, and scrolling are always accounted for.

export const PAGE_ID = 'ip-page'
export const TOPBAR_ID = 'ip-topbar'

/** Horizontal padding of the page container (App.tsx s.page). */
const PAGE_PADDING_X = 28

function setOverlayVars(): void {
  const page = document.getElementById(PAGE_ID)
  const topbar = document.getElementById(TOPBAR_ID)
  if (!page || !topbar) return
  const pageRect = page.getBoundingClientRect()
  const root = document.documentElement
  root.style.setProperty('--ip-overlay-top', `${Math.max(0, topbar.getBoundingClientRect().bottom)}px`)
  root.style.setProperty('--ip-overlay-left', `${pageRect.left + PAGE_PADDING_X}px`)
  root.style.setProperty('--ip-overlay-width', `${pageRect.width - 2 * PAGE_PADDING_X}px`)
}

/** Keep the overlay variables fresh while a modal is open. Returns a cleanup. */
export function trackOverlayVars(): () => void {
  setOverlayVars()
  window.addEventListener('resize', setOverlayVars)
  window.addEventListener('scroll', setOverlayVars, true)
  // Catches layout shifts that aren't resizes/scrolls (e.g. dismissing the
  // local-play banners above the app).
  const observer = new ResizeObserver(setOverlayVars)
  observer.observe(document.body)
  return () => {
    window.removeEventListener('resize', setOverlayVars)
    window.removeEventListener('scroll', setOverlayVars, true)
    observer.disconnect()
  }
}
